import React, { FC } from 'react';
import styles from './FiltersPanel.css';

export const FiltersPanel: FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <div className={styles['filters-panel-container']} data-name="FiltersPanel">
      {children}
    </div>
  );
};
